import { jsx } from 'react/jsx-runtime';
import { SliderA11yProvider } from './context/SliderA11yProvider.esm.js';
import { RangeSlider } from './range/RangeSlider.esm.js';
import { SingleSlider } from './single/SingleSlider.esm.js';

function Slider(props) {
    return (jsx(SliderA11yProvider, { children: props.variant === "range" ? (jsx(RangeSlider, Object.assign({}, props))) : (jsx(SingleSlider, Object.assign({}, props))) }));
}

export { Slider };
